import { Injectable } from '@angular/core';
import { RoutePartType } from '../../enums/route-part.enum';
import { TemplateConfiguration } from '../../models/template/template-configuration.model';
import { TemplatePart } from '../../models/template/template-part.model';
import { BusinessTransactionService } from '../../services/business-transaction/business-transaction.service';
import { RouteBuilderFactory } from '../route-builder/route-builder-factory.service';
import { TemplateConfigurationBaseService } from './template-configuration-base.service';

@Injectable()
/**
 * Service for creating transaction template configuration
 */
export class TransactionTemplateConfigurationService extends TemplateConfigurationBaseService {

    constructor(
        public _businessTransactionService: BusinessTransactionService,
        private routeBuilderFactory: RouteBuilderFactory
    ) {
        super();
    }

    /**
     * Gets the template configuration
     */
    public getTemplateConfiguration(): TemplateConfiguration {

        // define the template parts
        const bodyDef = new TemplatePart();
        bodyDef.name = RoutePartType.body;
        bodyDef.isDefaultNavigationTarget = true;

        const headerDef = new TemplatePart();
        headerDef.name = RoutePartType.head;

        const sidebarDef = new TemplatePart();
        sidebarDef.name = RoutePartType.sidebar;

        const primaryDef = new TemplatePart();
        primaryDef.name = RoutePartType.primary;

        const templateConfiguration: TemplateConfiguration = new TemplateConfiguration();
        templateConfiguration.name = 'default';
        templateConfiguration.templateParts = [
            primaryDef,
            bodyDef,
            headerDef,
            sidebarDef
        ];

        return templateConfiguration;
    }
}
